import { getConsent } from '@/shared/components/CookieConsent/CookieConsent'

const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'
const META_PIXEL_ID = '000000000000000'

let gaLoaded = false
let metaLoaded = false

export function initTracking() {
  const consent = getConsent()
  if (!consent) return

  if (consent.analytics) loadGA()
  if (consent.marketing) loadMetaPixel()
}

function loadGA() {
  if (gaLoaded) return
  gaLoaded = true

  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(s)

  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function () { window.dataLayer!.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', GA_MEASUREMENT_ID, { page_title: document.title, page_location: window.location.href })
}

function loadMetaPixel() {
  if (metaLoaded) return
  metaLoaded = true

  const fbq: FbqFn = function (...args: unknown[]) {
    const q = fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.q.push(args)
    return q
  }
  fbq.q = fbq.q || []
  fbq('init', META_PIXEL_ID)
  fbq('track', 'PageView')
  window.fbq = fbq

  const s = document.createElement('script')
  s.async = true
  s.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(s)
}

export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  const consent = getConsent()
  if (!consent) return
  if (consent.analytics && window.gtag) window.gtag('event', eventName, params)
  if (consent.marketing && window.fbq) window.fbq('track', eventName, params)
}

if (typeof window !== 'undefined') {
  window.addEventListener('consent-updated', () => initTracking())
}

// ── types ──
type FbqFn = {
  (...args: unknown[]): unknown
  callMethod?: (...args: unknown[]) => unknown
  q: unknown[]
}

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
    fbq?: FbqFn
    _fbq?: unknown
  }
}
